import { render, staticRenderFns } from "./DepartItem.vue?vue&type=template&id=ee8bd916&scoped=true&"
import script from "./DepartItem.vue?vue&type=script&lang=js&"
export * from "./DepartItem.vue?vue&type=script&lang=js&"
import style0 from "./DepartItem.vue?vue&type=style&index=0&id=ee8bd916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8bd916",
  null
  
)

export default component.exports